import * as React from 'react'
import CarouselProvider from './CarouselProvider'
import useCarousel from './useCarousel'

export type Action =
  | { type: 'increment' }
  | { type: 'decrement' }
  | { type: 'set'; payload: number }
export type State = { activeIndex?: number; component?: React.ReactNode }
type Dispatch = (action: Action) => void

export const CarouselContext = React.createContext<
  { state: State; dispatch: Dispatch } | undefined
>(undefined)

export { CarouselProvider, useCarousel }
